import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: '"Lucas solo comía pan y fideos. A los 20 días del protocolo aceptó su primer plato de carne con verduras sin llorar."',
    name: 'Verónica G.',
    location: 'Córdoba, Arg',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face'
  }, {
    text: '"Los bombones de Coco y Orégano son mágicos. Su barriga hinchada desapareció y por fin duerme 8 horas seguidas."',
    name: 'Lorena M.',
    location: 'Santiago, Chile',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face'
  }, {
    text: '"Usé el blister de remedios viejo como molde, ahora evacua a diario y toda la familia volvió a dormir toda la noche!!! Me devolvieron la vida."',
    name: 'Ana M.',
    location: 'Buenos Aires, Arg',
    avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=100&h=100&fit=crop&crop=face'
  }];
  return <section className="py-20 bg-white" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-teal mb-4" data-id="element-216">
            Familias Reales. Cambios Reales.
          </h2>
          <p className="text-lg text-gray-600" data-id="element-217">
            No escuches solo nuestra promesa, lee a las madres que ya cruzaron
            el puente.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-218">
          {testimonials.map((t, idx) => <div key={idx} className="bg-brand-cream rounded-2xl p-8 border border-gray-100 shadow-sm" data-id="element-219">
              <div className="flex gap-1 mb-4" data-id="element-220">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-221" />)}
              </div>
              <p className="text-gray-700 italic mb-6 text-lg" data-id="element-222">{t.text}</p>
              <div className="flex items-center gap-3" data-id="element-223">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover border-2 border-brand-gold/40" data-id="element-224" />
                <div data-id="element-225">
                  <p className="font-bold text-brand-dark" data-id="element-226">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-227">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}